import * as goldenrush from './CloseBtn.styles.goldenrush';
import * as juicybet from './CloseBtn.styles.juicybet';
import * as puntcity from './CloseBtn.styles.puntcity';
import * as sterlingparker from './CloseBtn.styles.sterlingparker';
import * as vikingbet from './CloseBtn.styles.vikingbet';
import * as forsport from './CloseBtn.styles.forsport';
import * as junglebet from './CloseBtn.styles.junglebet';
import * as oldgill from './CloseBtn.styles.oldgill';
import * as sugarcastle from './CloseBtn.styles.sugarcastle';
import * as buffalobet from './CloseBtn.styles.buffalobet';
import * as titanbet from './CloseBtn.styles.titanbet';
import * as bet777 from './CloseBtn.styles.bet777';
import * as gigabet from './CloseBtn.styles.gigabet';
import * as slambet from './CloseBtn.styles.slambet';
import * as betstride from './CloseBtn.styles.betstride';
import * as templebet from './CloseBtn.styles.templebet';
import * as goldenbet888 from './CloseBtn.styles.goldenbet888';
import * as hyperbet from './CloseBtn.styles.hyperbet';
import * as chromabet from './CloseBtn.styles.chromabet';
import * as bet575 from './CloseBtn.styles.bet575';
import * as epicodds from './CloseBtn.styles.epicodds';
import * as pyramidbet from './CloseBtn.styles.pyramidbet';
import * as magnumbet from './CloseBtn.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
